/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotesBody/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function NotesBody({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/Body/NotesBody"
  
}) {
let alertNameValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 textAlign="justify"
 textOverflow="wrap"
 data="alert.name"
 text={alertNameValueData}
/>
{children}
</React.Fragment>)
}